import { Label, styled } from '@auth0/quantum-product';
import * as React from 'react';
var StyledLabel = styled(Label)({
    verticalAlign: 'middle',
});
export var BetaBadge = function () { return (React.createElement(StyledLabel, { sx: { ml: 1 }, color: "primary", variant: "filled" }, "Beta")); };
